<template>
<section>
    <div id="nav">

  </div>
  <router-view/>
</section>
</template>

<style>

</style>
